export const SETTINGS_ROUTES = {
  ROOT: '/settings',

  USER_LIST: '/settings/users',
  USER_CREATE: '/settings/users/create',
  USER_DETAIL: (userId: string) => `/settings/users/${userId}` as const,
  USER_EDIT: (userId: string) => `/settings/users/${userId}/edit` as const,

  LABEL_LIST: '/settings/labels',
  LABEL_CREATE: '/settings/labels/create',
  LABEL_DETAIL: (labelId: string) => `/settings/labels/${labelId}` as const,
  LABEL_EDIT: (labelId: string) => `/settings/labels/${labelId}/edit` as const,

  LABEL_GROUP_LIST: '/settings/label-groups',
  LABEL_GROUP_CREATE: '/settings/label-groups/create',
  LABEL_GROUP_DETAIL: (labelGroupId: string) =>
    `/settings/label-groups/${labelGroupId}` as const,
  LABEL_GROUP_EDIT: (labelGroupId: string) =>
    `/settings/label-groups/${labelGroupId}/edit` as const,

  SUBLABEL_REQUEST_CREATE: '/settings/sublabel-requests/create',
} as const;
